import { render, staticRenderFns } from "./card-viewmore.vue?vue&type=template&id=a2a97dc4&scoped=true&"
import script from "./card-viewmore.vue?vue&type=script&lang=js&"
export * from "./card-viewmore.vue?vue&type=script&lang=js&"
import style0 from "./card-viewmore.vue?vue&type=style&index=0&id=a2a97dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a97dc4",
  null
  
)

export default component.exports